import {
  FILTER_PARTICIPANT_PROFILE,
  FILTER_ADMINISTRATOR_PROFILE,
} from "../constants";

// Filterstrategier
const filterBySearchText = (itemsToFilter, searchText) => {
  if (!searchText || searchText.length < 2) return itemsToFilter;
  return itemsToFilter.filter(
    (item) =>
      item.title.toLowerCase().includes(searchText.toLowerCase()) ||
      (item.description &&
        item.description.toLowerCase().includes(searchText.toLowerCase())),
  );
};

const filterByAdminstratorCourses = (itemsToFilter) => {
  return itemsToFilter.filter(
    (item) => item.profileId < FILTER_ADMINISTRATOR_PROFILE,
  );
};

export const filterByParticipantCourses = (itemsToFilter) => {
  return itemsToFilter.filter(
    (item) => item.profileId > FILTER_PARTICIPANT_PROFILE,
  );
};

const filterByCategory = (itemsToFilter, categoryId) => {
  return itemsToFilter.filter((item) => item.trainingCategoryId === categoryId);
};

const filterByTag = (itemsToFilter, selectedTags) => {
  if (!selectedTags || !Array.isArray(selectedTags)) return itemsToFilter;
  if (selectedTags.every((tag) => tag === 0)) return itemsToFilter;

  return itemsToFilter.filter((item) => {
    return selectedTags.some((tagId) => {
      if (tagId === 0) return false;

      if (item.tags && Array.isArray(item.tags)) {
        return item.tags.some((tag) => tag.valueId === tagId);
      }

      return false;
    });
  });
};

const strategies = {
  search: {
    filter: (items, searchText) => {
      if (!searchText || searchText.length < 2) return items;
      return filterBySearchText(items, searchText);
    },
  },
  displayAdminCourses: {
    filter: (items, displayAdminCourses) => {
      return displayAdminCourses
        ? filterByAdminstratorCourses(items)
        : filterByParticipantCourses(items);
    },
  },
  category: {
    filter: (items, categoryId) => {
      if (!categoryId) return items;
      return filterByCategory(items, categoryId);
    },
  },
  tags: {
    filter: (items, selectedTags) => {
      if (!selectedTags || !Array.isArray(selectedTags)) return items;
      return filterByTag(items, selectedTags);
    },
  },
};

const applyFilters = (items, activeFilters) => {
  return Object.entries(activeFilters).reduce(
    (filteredItems, [filterName, filterValue]) => {
      const strategy = strategies[filterName];
      return strategy
        ? strategy.filter(filteredItems, filterValue)
        : filteredItems;
    },
    items,
  );
};

const applyBasicFilters = (items, filter) => {
  let filteredItems = items;

  if (filter.searchText && filter.searchText.length >= 2) {
    filteredItems = filterBySearchText(filteredItems, filter.searchText);
  }

  filteredItems = filter.displayAdminCourses
    ? filterByAdminstratorCourses(filteredItems)
    : filterByParticipantCourses(filteredItems);

  if (filter.categoryId !== 0) {
    filteredItems = filterByCategory(filteredItems, filter.categoryId);
  }

  if (filter.selectedTags && Array.isArray(filter.selectedTags)) {
    filteredItems = filterByTag(filteredItems, filter.selectedTags);
  }

  return filteredItems || [];
};

const getNotStartedItems = (items, isProgramFilter) => {
  return items.filter((item) =>
    isProgramFilter
      ? item?.progress === 0
      : !item?.lastLoggedIn && !item?.completed,
  );
};

const getBegunItems = (items, isProgramFilter) => {
  return items.filter((item) =>
    isProgramFilter
      ? !item?.completed && item?.progress > 0
      : item?.lastLoggedIn && !item?.completed,
  );
};

const getCompletedItems = (items) => {
  return items.filter((item) => item?.completed);
};

const getLeftToDoItems = (items) => {
  return items.filter((item) => !item?.completed);
};

const createFilteredItems = (items, filter, isProgramFilter = false) => {
  const filteredItems = applyBasicFilters(items, filter);

  return {
    active: [...filteredItems],
    all: [...filteredItems],
    notstarted: getNotStartedItems(filteredItems, isProgramFilter),
    begun: getBegunItems(filteredItems, isProgramFilter),
    completed: getCompletedItems(filteredItems),
    lefttodo: getLeftToDoItems(filteredItems),
  };
};

const checkIsAdmin = (searchText, courses, currentIsAdmin) => {
  if (searchText) return currentIsAdmin;
  // User considered admin if there exists any admin course (profileId < 3)
  return !!courses.find((c) => c.profileId < FILTER_ADMINISTRATOR_PROFILE);
};

export const filterService = {
  applyFilters,
  filterBySearchText,
  filterByAdminstratorCourses,
  filterByParticipantCourses,
  filterByCategory,
  filterByTag,
  createFilteredItems,
  checkIsAdmin,
};
